import React from 'react'
import type { ComponentProps } from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'
import type { RacePreviewTipsCard } from '@core/Areas/Racing/Components/RaceContent/RacePreviewTipsCard'
import { useRaceContent } from './useRaceContent'

type CardProps = Omit<
  ComponentProps<typeof RacePreviewTipsCard>,
  'raceKey' | 'isRaceOpen' | 'race' | 'tipSource'
> & {
  authorTitle?: string
}

export function useRaceContentCardProps(
  meetingId: string,
  meetingDate: Date,
  raceNumber: number
): CardProps | null {
  const { isLoading, isError, content } = useRaceContent(meetingId, meetingDate, raceNumber)

  if (isLoading || isError || !content?.racePreview) {
    return null
  }

  return {
    title: content.title,
    authorTitle: getAuthorName(content.title),
    headerTrailContent: content.tipsterProfilePictureUrl ? (
      <TipsterImageStyled
        src={content.tipsterProfilePictureUrl}
        alt="Picture of this meeting'\''s expert"
      />
    ) : undefined,
    tips: content.racePreview.numbers ?? [],
    previewText: content.racePreview.previewText,
    suggestedBet: content.racePreview.suggestedBet,
    panelTestId: 'new-race-panel',
    containerTestId: 'new-race-content-panel',
  }
}

// ======
// Styles
// ======

const TipsterImageStyled = styled.img({
  height: 'auto',
  width: '2rem',
  backgroundColor: hexColors.amethyst,
  borderRadius: '50%',
})

// ======
// Local Helpers
// ======
const getAuthorName = (title: string): string => title.split("'s")[0].trim()
